import MicroModal from "micromodal"
import Modal from "../components/common/modal/Modal"
import { useEffect, useState } from 'react'

const BulkModal = ( props ) => {

    const [rowsSelected, setSelectedRows] = useState([...props.selectedRows.rows])
    const [currentInfosRole, setCurrentInfosRole] = useState(props.selectedRows.rows[0]?.original.role)
    const [memberPresets, setMemberPresets] = useState(props.selectedRows.rows[0]?.original.memberPresets.manage)
    MicroModal.init()

    console.log('props.selectedRows.rows : ', props.selectedRows.rows[0].original)
    console.log('memberPresets : ', typeof memberPresets, memberPresets)

    useEffect(() => {
        const infos = props.selectedRows.rows[0]?.original.role
        setCurrentInfosRole(infos)
        setSelectedRows([...props.selectedRows.rows])

        let currentMemberPresets
        (props.selectedRows.rows).forEach((row, index) => {
            if ( index === 0 ) {
                currentMemberPresets = row.original.memberPresets.manage
            } else {
                currentMemberPresets = currentMemberPresets + ',' + row.original.memberPresets.manage
            }
        });
        setMemberPresets(currentMemberPresets)
    }, [props.selectedRows.rows])

    return (
        <>
            <Modal modalId="msync-org-bulk-edit" buttonTitle="Apply">
                <header className="modal__header">
                    <h2 className="modal__title">Bulk Edit</h2>
                    <button type='button' className="modal__close" aria-label="Close modal" onClick={()=>MicroModal.close("msync-org-bulk-edit")}></button>
                </header>
                <main className="modal__content">
                    <div className="msync-row">
                        {
                            rowsSelected.map(row => {
                                return (
                                    <>
                                        <div>
                                            { row.original.username }
                                        </div>
                                        <div>
                                            { row.original.manage.fname + row.original.manage.lname }
                                        </div>
                                        <div>
                                            { row.original.email }
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                    <div className="msync-row">
                        { console.log('currentInfos : ', currentInfosRole) }
                        <div>
                            Role : {
                                tangibleFields.render({
                                    type: 'select',
                                    choices: {
                                        manager: 'Manager',
                                        member: 'Member'
                                    },
                                    value: currentInfosRole
                                })
                            }
                        </div>
                        <div>
                            Member Presets : {
                                tangibleFields.render({
                                    type: 'combo-box',
                                    name: 'membersync-org-bulk-member-presets',
                                    choices: rowsSelected[0].original.orgMemberPresets,
                                    multiple: true,
                                    value: memberPresets
                                })
                            }
                        </div>
                        <div>
                            Allocated Licenses : {
                                tangibleFields.render({
                                    type: 'combo-box',
                                    name: 'membersync-org-bulk-licenses',
                                    choices: rowsSelected[0].original.licenses,
                                    multiple: true
                                })
                            }
                        </div>
                    </div>
                </main>
            </Modal>
        </>
    );
};

export default BulkModal;